var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUsersIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.375C13.6756 13.375 16.25 10.8006 16.25 7.625C16.25 4.44936 13.6756 1.875 10.5 1.875C7.32436 1.875 4.75 4.44936 4.75 7.625C4.75 10.8006 7.32436 13.375 10.5 13.375Z",
    stroke: "#222222",
    strokeWidth: 1.96875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78418 18.4054C2.66785 16.8759 3.93846 15.6058 5.46839 14.7228C6.99831 13.8398 8.73366 13.375 10.5001 13.375C12.2666 13.375 14.0019 13.8399 15.5318 14.7229C17.0617 15.6059 18.3323 16.876 19.2159 18.4056",
    stroke: "#222222",
    strokeWidth: 1.96875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsersIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users_icon.f78d563e.svg";
export { ForwardRef as ReactComponent };